export enum XpoViewMgtMessages {
  // Save view
  SaveViewSuccess = 'View is saved successfully.',
  SaveViewAsSuccess = 'View is saved successfully.',
  // Rename view
  RenameViewSuccess = 'Selected view is renamed successfully.',
  // Delete view
  DeleteViewSuccess = 'View is deleted successfully',
}
